jQuery(function($) {
    /**
    * Open mobile menu on hamburger click
    */
   function toggleMenu(){
    // if($('.hamburger-btn').hasClass('is-open')){
    //   $('.hamburger-btn').removeClass('is-open');
    // } else{
    //   $('.hamburger-btn').addClass('is-open');
    // }
    // if($('.header__nav-mobile').hasClass('is-open')){
    //   $(this).removeClass('is-open');
    // } else{
    //   $(this).addClass('is-open');
    // }
      $('.hamburger-btn').toggleClass('is-open');
      $('.header__nav-mobile').toggleClass('is-open');
   }
    // $(document).ready(function() {
    //   $('.hamburger-btn').click(function() {
    //     $('.header__nav-mobile').animate({
    //       top: '230px'
    //     }, 100, function() {
    //       // if ($(window).scrollTop() >= 173) {
    //       //   $('.header__nav-mobile').css('display', 'block');
    //       // }
    //     });
    //   });
    // });


    /**
    * Scroll to top and open menu after hamburger click
    */
    $(document).ready(function() {
      $('.hamburger-btn').click(function() {
        $('html, body').animate({
          scrollTop: 0
        }, 'fast');
        $('.hamburger-btn').toggleClass('is-open');
        $('.header__nav-mobile').toggleClass('is-open');
        $('body').toggleClass('no-scroll');
        $(".sub-menu").removeClass("is-open");
      });
    });

    /**
    * Hide/show mobile menu after scroll
    */
    var scrollPos = $(window).scrollTop();

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var $header = $('.header__nav-hamburger-fixed');
    
      var scrollThreshold = 150;

      if (window.innerWidth >= 400 && window.innerWidth <= 560) {
        scrollThreshold = 80;
      }
      if (window.innerWidth < 400) {
        scrollThreshold = 70;
      }
      
      if (scroll >= scrollThreshold) {
        $header.addClass('fixed');
      } else {
        $header.removeClass('fixed');
      }
    
      if (scroll >= 650 && scroll >= scrollPos) {
        $header.addClass('header-up');
      } else if (scroll < scrollPos) {
        $header.removeClass('header-up');
      }
    
      scrollPos = scroll;
    });

    /**
    * Open drop down mobile menu on menu item click
    */
    $('.header__nav-mobile .menu-item-has-children').on('click', function() {
      $(this).find(".sub-menu").toggleClass('is-open');
    });

    /**
    * Switch tabs on click
    */
    // $(".contact-forms__form-title").on("click", function() {
    //   $(".contact-forms__form-title").each(function() {
    //     $(this).removeClass("active");
    //   });
    //   $(".contact-forms__form").each(function() {
    //     $(this).removeClass("active");
    //   });
    //   $(this).addClass("active");
    //   $(".contact-forms__form[data-tab='"+$(this).data("tab")+"']").addClass("active");
    // });

    /**
    * Accordion
    */
    $(".contact-forms__form-title").on("click", function() {
      $(".contact-forms__form").each(function() {
        $(this).removeClass("active");
      });
      $(this).parent().addClass("active");

    })
    
    /**
    * Reveal timeline items when in viewport
    */
    function inViewPort(){
      $('.timeline-item').each(function() {
        if($(window).scrollTop() + $(window).height() > $(this).offset().top) {
          $(this).addClass('in-view');
        }
      });
    }
    $(document).ready(function() {
      inViewPort();
    });
    $(window).on('scroll', function() {
      inViewPort();
    });


    /**
    * Add flex wrap if sub-menu does not fit the screen
    */
    $( document ).ready(function() {
      $('.sub-menu').each(function() {
        var $subMenu = $(this),
            subMenuPos = $subMenu.offset(),
            subMenuWidth = $subMenu.outerWidth();
    
        if (subMenuPos.left + subMenuWidth + 40 > $(window).width()) {
          $('.sub-menu').each(function() {
            $('.sub-menu').addClass('flex-wrap');
          });
        }
      });
    });



    // Default location
var defaultLat = 50.879780;
var defaultLon = 5.985470;

// Marker
var markerLat = 50.879780;
var markerLon = 5.985470;

// Custom colors
var markerColor = '#ffffff';

    $(document).ready(function() {
      // Create a new OpenLayers map
      var map = new ol.Map({
        target: 'map',
        layers: [
          new ol.layer.Tile({
            source: new ol.source.XYZ({
              url: 'https://{1-4}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'
            })
          })
        ],
        view: new ol.View({
          center: ol.proj.fromLonLat([defaultLon, defaultLat]),
          zoom: 16
        })
      });
    
      // Add a marker at the specified location
      var marker = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.fromLonLat([markerLon, markerLat]))
      });
      var markerVectorLayer = new ol.layer.Vector({
        source: new ol.source.Vector({
          features: [marker]
        })
      });
      map.addLayer(markerVectorLayer);
    
      // Customize the marker
      var markerStyle = new ol.style.Style({
        image: new ol.style.Icon({
          src: 'https://zuydnotarissen.nl/wp-content/themes/zuyd-notarissen/assets/images/icons/icon.svg',
          scale: 0.3,
          color: markerColor
        })
      });
      marker.setStyle(markerStyle);
    
    });
    
    $(document).ready(function() {
      $headerImgs = $('.header-image');
      $current = 0;
      $length = $headerImgs.length;

      $headerImgs.eq($current).addClass('active');

      setInterval(function() {
        $headerImgs.eq($current).removeClass('active');
        $current = ($current + 1) % $length;
        $headerImgs.eq($current).addClass('active');
      }, 4000);

      $headerImgsMobile = $('.header-image-mobile');
      $currentMobile = 0;
      $lengthMobile = $headerImgsMobile.length;

      $headerImgsMobile.eq($currentMobile).addClass('active');

      setInterval(function() {
        $headerImgsMobile.eq($currentMobile).removeClass('active');
        $currentMobile = ($currentMobile + 1) % $lengthMobile;
        $headerImgsMobile.eq($currentMobile).addClass('active');
      }, 4000);
    });
  });